import { handleErrorByMessage } from "@/shared/connection/with-store-error-handlers";
import { ajaxCall } from "@/shared/connection/ajax-call";

const ENDPOINT = "/user-impersonations";

export const impersonateService = {
    getModalData($lang = () => {}) {
        const modalData = {
            type: "imp",
            input: "",
            title: $lang({
                en: "Work on behalf of:",
                pl: "Pracuj w imieniu:",
            }),
            cancelBtn: $lang({ en: "Cancel", pl: "Anuluj" }),
            actionBtn: $lang({ en: "Start session", pl: "Zacznij sesję" }),
            callback: async () => {
                try {
                    await this.startSession(modalData.eid, modalData.reason);
                    window.location.reload();
                } catch {
                    /* empty */
                }
            },
        };
        return modalData;
    },
    startSession(eId, reason) {
        return ajaxCall.post(ENDPOINT, { eId, reason }).catch(handleErrorByMessage());
    },
};
